import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    marginVertical: 6,
    borderBottomColor: '#D1D5DB', // Tailwind gray-300 for light separator
    borderBottomWidth: 1,
  },
});

const InvoiceLine = () => (
  <View style={styles.titleContainer}></View>
);

export default InvoiceLine;
